export default {
  install(Vue) {
    Vue.prototype.$watchLocalStorage = function (key, callback) {
      // Cambios en la misma pestaña
      const originalSetItem = localStorage.setItem
      localStorage.setItem = function (k, v) {
        originalSetItem.apply(this, arguments)
        if (k === key) callback(v)
      }

      const originalRemoveItem = localStorage.removeItem
      localStorage.removeItem = function (k) {
        originalRemoveItem.apply(this, arguments)
        if (k === key) callback(null)
      }

      // Cambios en otras pestañas
      window.addEventListener("storage", (event) => {
        if (event.key === key) callback(event.newValue)
      })
    }
  }
}